function utf8_to_b64(str: string) {
  return btoa(unescape(encodeURIComponent(str)));
}

function b64_to_utf8(str: string) {
  return decodeURIComponent(escape(atob(str)));
}

export const Base64 = {
  decode: b64_to_utf8,
  encode: utf8_to_b64,
};
